import * as Yup from 'yup';

const minSubjectLength = 20;
const minDescriptionLength = 100;

const minLengthError = kwargs => interpolate(
	gettext('We need more information (minimum %(min)s characters required)'),
	{ min: kwargs.min },
	true,
);
const emailValidationError = () => gettext(
	'Enter a valid email',
);
const requiredError = () => ({
	required: true,
});
const phoneError = () => gettext(
	'Enter a valid phone number',
);

const createHelpdeskFormSchema = (props) => {
	const { fieldsToDisplay } = props;
	let yupShape = {
		phoneNum: Yup
			.string()
			.matches(/^[0-9() -]+$/, phoneError)
			.when('isRequestingPhone', (other, schema) => (other
				? schema.required(requiredError)
				: schema
			)),
	};
	if (!fieldsToDisplay.sslFields) {
		yupShape = {
		subject: Yup
			.string()
			.trim()
			.min(minSubjectLength, minLengthError)
			.required(requiredError),
		description: Yup
			.string()
			.trim()
			.min(minDescriptionLength, minLengthError)
			.required(requiredError),
		}
	}
	if (fieldsToDisplay.nameFields) {
		yupShape = {
			...yupShape,
			firstName: Yup
				.string()
				.trim()
				.required(requiredError),
			lastName: Yup
				.string()
				.trim()
				.required(requiredError),
			email: Yup
				.string()
				.trim()
				.email(emailValidationError)
				.required(requiredError),
		};
	}
	if (fieldsToDisplay.relatedPrograms && fieldsToDisplay.relatedPrograms.required) {
		yupShape = {
			...yupShape,
			relatedPrograms: Yup
				.string()
				.required(requiredError),
		};
	}
	if (fieldsToDisplay.relatedStages && fieldsToDisplay.relatedStages.required) {
		yupShape = {
			...yupShape,
			relatedStages: Yup
				.string()
				.required(requiredError),
		};
	}
	if (fieldsToDisplay.relatedTasks && fieldsToDisplay.relatedTasks.required) {
		yupShape = {
			...yupShape,
			relatedTasks: Yup
				.string()
				.required(requiredError),
		};
	}
	if (fieldsToDisplay.relatedUsers && fieldsToDisplay.relatedUsers.required) {
		yupShape = {
			...yupShape,
			relatedUsers: Yup
				.string()
				.required(requiredError),
		};
	}
	if (fieldsToDisplay.relatedApplications && fieldsToDisplay.relatedApplications.required) {
		yupShape = {
			...yupShape,
			relatedApplications: Yup
				.string()
				.required(requiredError),
		};
	}
	if (fieldsToDisplay.relatedReports && fieldsToDisplay.relatedReports.required) {
		yupShape = {
			...yupShape,
			relatedReports: Yup
				.string()
				.required(requiredError),
		};
	}
	if (fieldsToDisplay.relatedAutomations && fieldsToDisplay.relatedAutomations.required) {
		yupShape = {
			...yupShape,
			relatedAutomations: Yup
				.string()
				.required(requiredError),
		};
}
	if (fieldsToDisplay.sslFields) {
	yupShape = {
		...yupShape,
		sslDomainName: Yup
			.string()
			.trim()
			.required(requiredError),
		sslCountry: Yup
			.string()
			.trim()
			.required(requiredError),
		sslState: Yup
			.string()
			.trim()
			.required(requiredError),
		sslCity: Yup
			.string()
			.trim()
			.required(requiredError),
		sslOrganizationName: Yup
			.string()
			.trim()
			.required(requiredError),
		sslDepartmentName: Yup
			.string()
			.trim()
			.required(requiredError),
		sslEmail: Yup
			.string()
			.trim()
			.email(emailValidationError)
			.required(requiredError),
	};
	}
	return Yup.object().shape(yupShape);
};

export default createHelpdeskFormSchema;
